import React from "react";
// import NuevoPedido from "../../NuevoPedido/NuevoPedido";
import NuevoPedido from "../../NuevoPedido/componetizado/NuevoPedido";
import AsignarPedido from "../../asignarPedido/AsignarPedido";
import AsignarPedidoGrupo from "../../asignarPedido/AsignarPedidoGrupo";
import AnularPedido from "../../anularPedido/AnularPedido";
// import EditarPedido from "../../EditarPedido/EditarPedido";
import EditarPedido from "../../EditarPedido/componetizado/EditarPedido";
import ReclamarPedido from "../../reclamarPedido/ReclamarPedido";
import ReabrirPedido from "../../reabrirPedido/ReabrirPedido";
import ModalFacturar from "../../facturarPedido/ModalFacturar";
import GenerarLinkPago from "../../linkPago/GenerarLinkPago";
import DialogVerLink from "../../linkPago/verLink/DialogVerLink";

// Punto único donde se montan los modales de acción reutilizados del módulo
// original. Tabla y tarjetas comparten este mismo host: ambas vistas abren
// los mismos componentes probados, solo cambia quién dispara `abrirModal`.
const ModalesPedidoHost = ({
  modales,
  pedidoActivo,
  cerrarModal,
  asignarEnGrupoAbierto,
  rowsAsignarGrupo,
  onCerrarAsignarGrupo,
}) => (
  <>
    {modales.nuevoPedido && <NuevoPedido open={modales.nuevoPedido} setOpen={() => cerrarModal("nuevoPedido")} />}

    {modales.asignar && pedidoActivo && (
      <AsignarPedido open={modales.asignar} setOpen={() => cerrarModal("asignar")} dataPedido={pedidoActivo} />
    )}

    {asignarEnGrupoAbierto && (
      <AsignarPedidoGrupo open={asignarEnGrupoAbierto} setOpen={onCerrarAsignarGrupo} rowsAsignar={rowsAsignarGrupo} />
    )}

    {modales.anularPedido && pedidoActivo && (
      <AnularPedido open={modales.anularPedido} setOpen={() => cerrarModal("anularPedido")} dataPedido={pedidoActivo} />
    )}

    {modales.editarPedido && pedidoActivo && (
      <EditarPedido open={modales.editarPedido} setOpen={() => cerrarModal("editarPedido")} dataPedido={pedidoActivo} />
    )}

    {modales.reclamarPedido && pedidoActivo && (
      <ReclamarPedido open={modales.reclamarPedido} setOpen={() => cerrarModal("reclamarPedido")} dataPedido={pedidoActivo} />
    )}

    {modales.reabrir && pedidoActivo && (
      <ReabrirPedido open={modales.reabrir} setOpen={() => cerrarModal("reabrir")} dataPedido={pedidoActivo} />
    )}

    {modales.facturar && pedidoActivo && (
      <ModalFacturar open={modales.facturar} onClose={() => cerrarModal("facturar")} dataPedido={pedidoActivo} />
    )}

    {modales.linkPago && pedidoActivo && (
      <GenerarLinkPago open={modales.linkPago} onClose={() => cerrarModal("linkPago")} dataPedido={pedidoActivo} />
    )}

    {modales.verLink && pedidoActivo && (
      <DialogVerLink open={modales.verLink} onClose={() => cerrarModal("verLink")} dataPedido={pedidoActivo} />
    )}
  </>
);

export default ModalesPedidoHost;
